import { Utility, utility_controller } from '../utility/utility_controller'
import history_controller from './history_controller_new'
import mobile_menu_controller from '../mobile/mobile_menu_controller'
import { showHideAllOverlays } from '../page_overlay/page_overlay'
import page_overlay_loader from '../page_overlay/page_overlay_loader'
import unescape from 'lodash/unescape'
import { canUseAjaxNavigation } from './navigation_policy'
import hard_navigation_transition from './hard_navigation_transition'

// todo: when in customizer, dont make cart button go to cart when sidecart plugin is active

var didBindCustomizerPageOverlayLinks = false

var isCustomizerPreview = function () {
	return layData.is_customize == true || layData.is_customize == '1' || layData.is_customize == 'true'
}

var openPageOverlayHref = function (href, link) {
	if (!href) {
		return false
	}

	href = utility_controller.filterURL(href)
	if (showHideAllOverlays(href)) {
		return true
	}
	return page_overlay_loader.openIfKnown(link || null, href, showHideAllOverlays)
}

var bindCustomizerPageOverlayLinks = function () {
	if (didBindCustomizerPageOverlayLinks || !isCustomizerPreview()) {
		return
	}

	didBindCustomizerPageOverlayLinks = true
	window.laythemeOpenPageOverlayHref = openPageOverlayHref

	document.addEventListener(
		'click',
		function (event) {
			var target = event.target
			if (!target || typeof target.closest != 'function') {
				return
			}

			var link = target.closest('a[href]:not([target="_blank"])')
			if (!link) {
				return
			}

			var href = link.getAttribute('href')
			if (!href) {
				return
			}

			if (openPageOverlayHref(href, link)) {
				event.preventDefault()
				event.stopPropagation()
				if (typeof event.stopImmediatePropagation == 'function') {
					event.stopImmediatePropagation()
				}
			}
		},
		true
	)
}

var bindAnchors = function () {
	bindCustomizerPageOverlayLinks()

	jQuery(document).on('click', 'a[data-type]:not([target="_blank"])', function (event) {
		// dont do anything if parent is .laycart (woocommerce) and sidecart is active
		if (jQuery(this.parentNode).hasClass('laycart') && layData.sideCartPluginActive == true) {
			event.preventDefault()
			event.stopPropagation()
			return
		}

		var $this = jQuery(this)
		var href = $this.attr('href')
		href = utility_controller.filterURL(href)

		// Page overlays are an in-page UI and must be resolved before the generic
		// hard-navigation policy. WooCommerce geolocation and analytics plugins can
		// decorate their links with query parameters, which otherwise makes the
		// navigation policy treat a valid overlay link as a normal page load.
		var isOverlayLink = openPageOverlayHref(href, this)
		if (isOverlayLink) {
			event.preventDefault()
			event.stopPropagation()
			return
		}

		if (layData.navigation_policy && layData.navigation_policy.enabled && !canUseAjaxNavigation({ id: $this.attr('data-id'), type: $this.attr('data-type') }, href)) {
			if (!event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button !== 1) {
				var didHandleHardNavigation = hard_navigation_transition.navigate(
					href,
					{ id: $this.attr('data-id'), type: $this.attr('data-type'), slug: $this.attr('data-slug') },
					this
				)
				if (didHandleHardNavigation) {
					event.preventDefault()
				}
			}
			return
		}

		var ua = (navigator.userAgent || navigator.vendor || window.opera).toLowerCase()
		var isInstagram = ua.indexOf('instagram') > -1 ? true : false

		// dont ajax when in customizer
		// dont ajax when in instagram browser (only if project overlays are disabled for IG), cause otherwise back and forth buttons wont work
		var isProjectLinkOnDisabledTouchDevice = $this.attr('data-type') == 'project' && layData.disable_projectsoverlays_on_touchdevices == 'on' && Utility.isTouchDevice
		if (layData.is_customize || (isInstagram && layData.disable_projectsoverlays_on_ig == 'on') || isProjectLinkOnDisabledTouchDevice) {
			return
		}

		// don't do anything when on the same page
		if (jQuery('body').attr('data-type') == jQuery(this).attr('data-type') && jQuery('body').attr('data-id') == jQuery(this).attr('data-id')) {
			event.preventDefault()

			mobile_menu_controller.hideMobileMenu()
		}
		// check if this is not a custom link and nor command neither ctrl are pressed
		else if (jQuery(this).attr('data-type') != 'custom' && !event.metaKey && !event.ctrlKey) {
			event.preventDefault()
			var qtranslateLang = ''
			if (window.layCachePreload && typeof window.layCachePreload.getQTranslateLangForNavigation === 'function') {
				qtranslateLang = window.layCachePreload.getQTranslateLangForNavigation(href)
			}
			var title = passedDataHistory.title
			var attr_title = $this.attr('data-title')
			if (typeof attr_title != 'undefined' && attr_title != '') {
				title = passedDataHistory.titleprefix + unescape($this.attr('data-title'))
			}
			var catid = $this.attr('data-catid') // Store as string, not array
			if (layData.misc_options_disable_ajax != 'on') {
				// When Yoast is active, skip setting document.title on click; layout response will set correct Yoast title (avoids flash of wrong title)
				var skipTitleUpdate = layData.document_title_from_server === true || layData.document_title_from_server === 'true' || layData.document_title_from_server === '1'
				history_controller.pushState(
					{
						type: $this.attr('data-type'),
						id: $this.attr('data-id'),
						catid: catid,
						title: title,
						slug: $this.attr('data-slug'),
						qtranslate_lang: qtranslateLang,
					},
					title,
					href,
					skipTitleUpdate ? { skipTitleUpdate: true } : undefined
				)
			} else {
				// https://stackoverflow.com/questions/1226714/how-to-get-the-browser-to-navigate-to-url-in-javascript
				window.location.href = href
			}
		}
	})
}

export { bindAnchors }
